import React from 'react'
import { Link } from 'react-router-dom'

import Icon from '../static/icon'

import styles from './linkIconWrapper.module.scss'

const getClassName = type => {
  switch (type) {
    case 'primary':
      return styles.linkIconWrapper_primary
    case 'secondary':
      return styles.linkIconWrapper_secondary
    default:
      return styles.buttonIconWrappe
  }
}

const LinkIconWrapper = props => {
  const { type, icon, link } = props

  return (
    <Link className={getClassName(type)} to={link}>
      <Icon name={icon} />
    </Link>
  )
}

export default React.memo(LinkIconWrapper)